<template>
  <div class="about">
    <p class="klein tac p-3">Stelling {{ current }} - {{ total }}</p>

    <div class="o-grid__item u-size-12 u-size-8@desktop u-align-center">
      <article class="c-article">
        <div class="c-article__content">
          <b-progress :value="current" :max="total" animated></b-progress>
          <h3 class="tac">{{ currentCat.name }}</h3>
          <h4 class="klein">{{ currentCat.subtitle }}</h4>
          <div class="questioncontainer d-flex">
            <transition name="slide-fade" mode="out-in">
              <p :key="question.question">{{question.question}}</p>
            </transition>
          </div>
          <p class="klein tac">Hoezeer is deze stelling van toepassing?</p>

          <div class="answers">
            <div
              @click.prevent="setValue(i)"
              v-for="i in 10"
              v-bind:key="i"
              href="?page=1"
              class="answer"
              :class="{'currentanswer': value == i, 'loweranswer': value && value > i ,
              
              'selectMe':  grow && value == i}"
            >{{ i }}</div>
          </div>
        <div class="byline">
          <p>Volledig oneens</p><p>Volledig eens</p>
        </div>

          <div class="nextbar">
            <b-button @click="previous" :disabled="current == 1">Vorige vraag</b-button>
            <b-button
              @click="next"
              v-if="current < total"
              :disabled="value == undefined"
            >Volgende vraag</b-button>
            <b-button @click="done" v-if="current == total">Klaar</b-button>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      grow: false
    };
  },
  methods: {
    previous() {
      this.current -= 1;
    },
    next() {
      this.current += 1;
    },
    setValue(newValue) {
      //selectMe
      if (!this.grow) {
        this.grow = true;
        this.value = newValue;
        let that = this;
        setTimeout(function() {
          that.grow = false;
          if (that.current == that.total) {
            that.done();
          } else {
            that.next();
          }
        }, 800);
      }
    },
    done() {
      this.$router.push({ name: "Radar" });
    }
  },
  computed: {
    currentCat() {
      return this.$store.state.data.dimensions.filter(
        x => x.id == this.question.dimension
      )[0];
    },
    data() {
      return this.$store.state.data;
    },
    total() {
      return this.$store.state.data.questions.length;
    },
    question() {
      let id = this.current - 1;
      return this.$store.state.data.questions[id];
    },
    current: {
      get() {
        var current = this.$store.state.current;
        if (current > this.total) current = 1;
        return current;
      },
      set(newValue) {
        return this.$store.dispatch("setCurrent", newValue);
      }
    },
    value: {
      get() {
        return this.$store.state.value[this.current];
      },
      set(newValue) {
        let copy = Object.assign({}, this.$store.state.value, {
          [this.current]: newValue
        });
        return this.$store.dispatch("setValue", copy);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
button.slider {
  transition: all 0.9s ease-out;
  background-color: #eee;
  color: #000;
}

button.notdone {
  background-color: #fff;
  color: #000 !important;
}

button.selected {
  background-color: black;
  color: #fff;
}

button.active {
  color: red;
}
button.active:hover {
  color: red !important;
}


h4 {
  text-align: center;
}
h2,
.nextbar {
  padding: 1.3rem 0;
}

.byline, .nextbar {
  display: flex;
  justify-content: space-between;
}

.klein {
  color: #716055;
  font-size: 0.8rem;
}

.questioncontainer {
  min-height: 190px;
  display: flex;
  justify-items: center;
  align-items: center;
  p {
    font-size: 1.4rem;
    text-align: center;
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
